import script from "./PopUpInsertLatex.vue?vue&type=script&setup=true&lang=js"
export * from "./PopUpInsertLatex.vue?vue&type=script&setup=true&lang=js"

import "./PopUpInsertLatex.vue?vue&type=style&index=0&id=6ecd8e5f&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6ecd8e5f"]])

export default __exports__